import React, { useEffect, useState } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import * as filestack from "filestack-js";

import "../projects/projects.css";
import { Grid, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { Box } from "@mui/system";
const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

export const Addalready = () => {
  let navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  // const [projectImage, setProjectImage] = useState("");
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [projectImages, setProjectImages] = useState([]);

  const [uploadedImageLink, setUploadedImageLink] = useState("");
  const [participentCount, setParticipentCount] = useState(0);
  const [projectFile, setProjectFile] = useState(null);
  const onChange = (e) => {
    let temp = Object.assign(data, { [e.target.name]: e.target.value });
    setData(temp);
    console.log("updated data>> ", temp);
    if (e.target.name == "totalParticipents") {
      setParticipentCount(parseInt(e.target.value));
    }
  };

  const uploadProjectImage = async (e) => {
    console.log("e.targte", e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const dataa = new FormData();
      dataa.append("file", files[0]);
      dataa.append("upload_preset", "bpyoqbty");

      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dqmbkvawu/image/upload",

        {
          method: "POST",
          body: dataa,
        }
      );
      const file = await res.json();
      console.log("response from cloudinary>>>", file);
      setUploadedImageLink(file?.secure_url);
      // setProjectImage(file?.secure_url);

      // let e2 = { target: { name: "projectImage", value: file?.secure_url } };
      // onChange(e2);
    }

    // console.log("file profie image>>> ", file);
  };
  const addProjectImage = () => {
    let arr = projectImages;
    console.log("uploadedImageLink", uploadedImageLink);
    if (uploadedImageLink && projectImages?.length < 6) {
      arr.push(uploadedImageLink);
      console.log("uploadedImageLink", uploadedImageLink);
      setUploadedImageLink("");
      setProjectImages(arr);
    }
    console.log("project images", arr);
  };
  const submitData = (e) => {
    console.log("data", data);
    console.log("images", projectImages);

    e.preventDefault();
    let errs = {};
    if (!data.title) {
      errs.title = "required";
    }
    if (!data.projectType) {
      errs.projectType = "required";
    }

    // if (!data.projectLink) {
    //   errs.projectLink = "required";
    // }
    // if (!data.projectFileUrl) {
    //   errs.projectFileUrl = "required";
    // }
    if (!data.techUsed) {
      errs.techUsed = "required";
    }
    if (!data.supervisor) {
      errs.supervisor = "required";
    }
    if (data.totalParticipents && participentCount < 1) {
      errs.totalParticipents = "add atleast one participent";
    }
    // if (!data.projectImage) {
    //   errs.projectImage = "image is required";
    // }
    if (!data.description) {
      errs.description = "required";
    }
    if (!data.completionDate) {
      errs.completionDate = "required";
    } else if (new Date(data.completionDate) > new Date(Date.now())) {
      errs.completionDate = " cannot be exceeds from current date";
    }
    let participents = [];
    if (participentCount == 1) {
      if (!data.participent1) {
        errs.participent1 = "required";
      }
      participents.push(data.participent1);
    }
    if (participentCount == 2) {
      if (!data.participent2) {
        errs.participent2 = "required";
      }
      if (!data.participent1) {
        errs.participent1 = "required";
      }
      participents.push(data.participent1);
      participents.push(data.participent2);
    }
    if (participentCount == 3) {
      if (!data.participent3) {
        errs.participent3 = "required";
      }
      if (!data.participent2) {
        errs.participent2 = "required";
      }
      if (!data.participent1) {
        errs.participent1 = "required";
      }
      participents.push(data.participent1);
      participents.push(data.participent2);
      participents.push(data.participent3);
    }
    console.log("errs", errs);
    setErrors(errs);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      let body = Object.assign(data, {
        userId: currentUser?.id,
        projectImages,
        participentsNames: participents,
        isAlreadyCreated: true,
      });
      console.log("submitting data", body);
      api
        .post("/FYPs", body)
        .then((res) => {
          Swal.fire("FYP Added Successfully!", "", "success");

          console.log(res.data);
          let notifBody = {
            userId: currentUser?.id,
            text: `${currentUser?.name} added an already created FYP.`,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.href = "/fyp/seealready";
        })
        .catch((err) => {
          console.log(err);
          swalWithBootstrapButtons.fire(
            "FYP Uploading Unsuccessful!",
            "Something goes wrong",
            "error"
          );
        });
    }
  };

  const submitToFileStack = (e) => {
    console.log("running on change file stack");
    const client = filestack.init("AdMqjDEfnTReoAz7UMbqxz");
    if (projectFile) {
      client.upload(projectFile).then((data) => {
        console.log("uploaded file url", data.url);
        let e = {
          target: {
            name: "projectFileUrl",
            value: data.url,
          },
        };
        onChange(e);
      });
    }
  };
  useEffect(() => {
    submitToFileStack();
  }, [projectFile]);
  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-10 col-12">
          <div className="container">
            <Typography className="my-4" variant="h6" sx={{ fontSize: "600" }}>
              Add Already Created Idea:
            </Typography>
            <div className="form">
              <div className="col-lg-12 col-12 m-auto">
                <div className="row">
                  <div className="col-lg-4 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc "
                      name="title"
                      placeholder="title"
                      type={"text"}
                      id="title"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.title && (
                      <p className="error__para">{errors.title}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-12">
                    <select
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="projectType"
                      onChange={(e) => onChange(e)}
                    >
                      <option value="">Project Type</option>
                      <option value="Mobile Application">
                        Mobile Application
                      </option>
                      <option value="Web Application">Web Application</option>
                      <option value="Desktop Application">
                        Desktop Application
                      </option>
                      <option value="Game Development">Game Development</option>
                      <option value="Research Work">Research Work</option>
                      <option value="Data Science">Data Science</option>
                      <option value="Machine Learning">Machine Learning</option>
                      <option value="Artificial Intelligence">
                        Artificial Intelligence
                      </option>
                    </select>

                    {errors.projectType && (
                      <p className="error__para">{errors.projectType}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="techUsed"
                      placeholder="Technology Used"
                      type="text"
                      id="techUsed"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.techUsed && (
                      <p className="error__para">{errors.techUsed}</p>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-4 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc "
                      name="supervisor"
                      placeholder="supervisor"
                      type={"text"}
                      id="supervisor"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.supervisor && (
                      <p className="error__para">{errors.supervisor}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="coSupervisor"
                      placeholder="Co Supervisor"
                      type="text"
                      id="coSupervisor"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.coSupervisor && (
                      <p className="error__para">{errors.coSupervisor}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="completionDate"
                      placeholder="Date of Completion*"
                      type="text"
                      onFocus={(e) => (e.target.type = "date")}
                      onBlur={(e) => (e.target.type = "text")}
                      id="completiondate"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.completionDate && (
                      <p className="error__para">{errors.completionDate}</p>
                    )}
                  </div>
                </div>
                <div className="row">
                  <Typography variant="p">Select file(pdf or doc)</Typography>
                  <Box
                    className="col-lg-4 col-12"
                    sx={{ alignItems: "center" }}
                  >
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      type="file"
                      onChange={(e) => setProjectFile(e.target.files[0])}
                    />

                    {errors.projectFileUrl && (
                      <p className="error__para">{errors.projectFileUrl}</p>
                    )}
                  </Box>
                  {/* <Box className="col-lg-4 col-12" sx={{ marginTop: "-10px" }}>
                    {data?.projectFileUrl ? (
                      <p>File Uploaded</p>
                    ) : (
                      <button
                        className="asc__submit__form__button"
                        onClick={(e) => submitToFileStack(e)}
                        disabled={projectFile ? false : true}
                      >
                        Upload File
                      </button>
                    )}
                  </Box> */}
                </div>
                <div className="row">
                  <div className="col-lg-4 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="projectLink"
                      placeholder="Project Link"
                      type={"text"}
                      id="projectlink"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.projectLink && (
                      <p className="error__para">{errors.projectLink}</p>
                    )}
                  </div>
                  {/* <div className="col-lg-4 col-12">
                    <input
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                      name="projectFile"
                      placeholder="Add file"
                      type="file"
                      id="projectFile"
                      required
                      onChange={(e) => onChange(e)}
                    ></input>
                    {errors.projectFile && (
                      <p className="error__para">{errors.projectFile}</p>
                    )}
                  </div> */}
                  <div className="col-lg-4 col-12">
                    <select
                      name="totalParticipents"
                      onChange={(e) => onChange(e)}
                      className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                    >
                      <option value="">Total Participents(1,2 or 3)</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                    </select>

                    {errors.totalParticipents && (
                      <p className="error__para">{errors.totalParticipents}</p>
                    )}
                  </div>
                </div>
                <div className="row">
                  {participentCount > 0 && (
                    <div className="col-lg-4 col-12">
                      <input
                        className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc "
                        name="participent1"
                        placeholder="participent 1"
                        type={"text"}
                        id="participent1"
                        required
                        onChange={(e) => onChange(e)}
                      ></input>
                      {errors.participent1 && (
                        <p className="error__para">{errors.participent1}</p>
                      )}
                    </div>
                  )}
                  {participentCount > 1 && (
                    <div className="col-lg-4 col-12">
                      <input
                        className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                        name="participent2"
                        placeholder="Participent 2"
                        type="text"
                        id="participent2"
                        required
                        onChange={(e) => onChange(e)}
                      ></input>
                      {errors.participent2 && (
                        <p className="error__para">{errors.participent2}</p>
                      )}
                    </div>
                  )}
                  {participentCount > 2 && (
                    <div className="col-lg-4 col-12">
                      <input
                        className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                        name="participent3"
                        placeholder="Participent 3"
                        type="text"
                        id="participent3"
                        required
                        onChange={(e) => onChange(e)}
                      ></input>
                      {errors.participent3 && (
                        <p className="error__para">{errors.participent3}</p>
                      )}
                    </div>
                  )}
                </div>
                <Box className="row " sx={{ marginBottom: "50px" }}>
                  <Typography
                    className="col-12 mt-4"
                    variant="p"
                    sx={{ textAlign: "left", marginBottom: "10px" }}
                  >
                    Project Images
                  </Typography>
                  <Box className="col-12 col-sm-12 col-md-9">
                    <input
                      type="file"
                      className="text-feild input__field__asc"
                      id=""
                      placeholder="write details"
                      name=""
                      required
                      onChange={(e) => uploadProjectImage(e)}
                      height="300px"
                    />
                  </Box>
                  <Box className="col-12 col-sm-12 col-md-3">
                    <button
                      className="asc__submit__form__button"
                      style={{ marginTop: "13px" }}
                      onClick={() => addProjectImage()}
                    >
                      Add Image
                    </button>
                  </Box>
                  <Typography>Note: you can add up to 6 images</Typography>
                  {errors.projectImages && (
                    <p className="error__para">{errors.projectImages}</p>
                  )}
                  <Grid container gap={3} sx={{ marginTop: "20px" }}>
                    {projectImages?.map((img) => (
                      <Grid item sm={3} xs={12}>
                        <img src={img} height="300px" width="300px" />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
                <textarea
                  className="p-2 border border-dark rounded my-2 w-full text-area input__field__asc "
                  name="description"
                  placeholder="Description"
                  type={"text"}
                  id="description"
                  required
                  onChange={(e) => onChange(e)}
                ></textarea>
                {errors.description && (
                  <p className="error__para">{errors.description}</p>
                )}

                <button
                  className=" asc__submit__form__button cancel__form__btn"
                  onClick={() => navigate("/fyp")}
                >
                  Cancel
                </button>
                <button
                  className="asc__submit__form__button mt-3"
                  onClick={(e) => submitData(e)}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
